import { types, actions } from './requests'
export const GETJOBLIST_TYPES = {
    ...types('GETJOBLIST'),
}
export const GETJOBLIST_ACTIONS = {
    ...actions('GETJOBLIST'),
}
